/* 推荐清单 */
import React, { useState, useEffect } from 'react'
import { Input, Button, Table, message, Spin, Pagination } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { recommendCourseList, recommendCourseListExport, infoProvince, recommendUpload } from "../../../../http/modules/province";
import daoChu from '../../../../img/daoChu.svg'
import Oss from '../../../../components/ossUpload/oss'
import './index.scss'

export default function Index() {

  const [selectionType, setSelectionType] = useState('checkbox');
  // 推荐作品数量
  const [recommend, setRecommend] = useState(0)
  // table 数据
  const [playerlist, setPlayerlist] = useState()
  // 作品数量  分页器总数
  const [number, setNumber] = useState(0)
  // 分页器  当前页数
  const [current, setCurrent] = useState(1)
  // loding
  const [loading, setLoading] = useState(false)
  // 地区名字
  const [kclb, setKclb] = useState()
  // 推荐表Url 
  const [formUrl, setFormUrl] = useState()
  // 推荐表文件名称 
  const [formName, setFormName] = useState()

  // Table 选中
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
  };

  // table格式
  const columns = [
    {
      title: '授课人',
      dataIndex: 'playerName',
      key: 'playerName',
      className: 'table',
      ellipsis: true,
      width: 90
    },
    {
      title: '申报单位',
      dataIndex: 'orgName',
      key: 'orgName',
      className: 'table',
      ellipsis: true,
      width: 285
    },
    {
      title: '课程名称',
      dataIndex: 'title',
      key: 'title',
      className: 'table',
      ellipsis: true,
      width: 285
    },
    {
      title: '课程类别',
      dataIndex: 'category',
      key: 'category',
      className: 'table'
    },
    {
      title: '授课类型',
      dataIndex: 'typ',
      key: 'typ',
      className: 'table'
    },
    {
      title: '评审状态',
      dataIndex: 'ProvinceAudit',
      key: 'ProvinceAudit',
      className: 'table'
    },
    {
      title: '合规性审查',
      dataIndex: 'provinceHegui',
      key: 'provinceHegui',
      className: 'table'
    },
    {
      title: '作品分数',
      dataIndex: 'provinceScore',
      key: 'provinceScore',
      className: 'table'
    }
  ];

  // 分页器点击回调
  const onPagination = (page, pageSize) => {

  }

  // 推荐列表
  const onRecommendCourse = async (page, category = '', auditState = '', searchTxt = '') => {
    try {
      const res = await recommendCourseList();
      if (res.code == 0) {
        if (res.data.list) {
          setRecommend(res.data.list.length)
          setCurrent(res.data.pageNo)
          let arr = res.data.list
          if (!arr) {
            setPlayerlist()
            return
          }
          arr.map((item) => {
            item.key = item.courseUUID
            return item
          })
          setPlayerlist(arr)
        }
      }
    } catch (err) {
      message.error(err.response.data?.msg);
    }
  };

  // 导出
  const derive = async () => {
    setLoading(true)
    try {
      const res = await recommendCourseListExport();
      if (res) {
        const blob = new Blob([res]);
        const url = window.URL.createObjectURL(blob);
        const temp = document.createElement('a');// 创建a标签
        temp.href = url;
        temp.download = `推荐列表.xlsx`;
        temp.click();
        window.URL.revokeObjectURL(url);// 释放内存
        message.success('导出成功！')
        setLoading(false)
      } else {
        setLoading(false)
        message.error('导出失败！');
      }
    } catch (err) {
      setLoading(false)
      message.error(err.response.data?.msg);
    }
  }

  // 机构详情
  const onFinish = async () => {
    try {
      const res = await infoProvince();
      if (res.code == 0) {
        setKclb(res.data)
      }
    } catch (err) {
      message.error(err.response.data?.msg);
    }
  };

  // 上传推荐表
  const upload = async () => {
    try {
      const res = await recommendUpload({
        urlRecommend: formUrl
      });
      if (res) {
        onFinish()
      }
    } catch (err) {
      message.error(err.response.data?.msg);
    }
  }

  useEffect(() => {
    onRecommendCourse()
    onFinish()
  }, [])

  // 上传推荐表
  useEffect(() => {
    if (!formUrl) { return }
    upload()
  }, [formUrl])

  return (
    <Spin spinning={loading}>
      <div className='recommendationList'>
        <header>
          <p> <span>{recommend}</span>个推荐作品（≤30）</p>
          <div className='headerButton'>
            {kclb?.provinceAdmin?.isRecommend == 1 ? <div className='button' onClick={() => { message.success('您已上传推荐表') }}>上传推荐表</div>
              : <div className='button'><Oss url={setFormUrl} province={'provinceRecommend'} title={'*'} kclb={kclb?.provinceAdmin?.loginName} Name={setFormName} />上传推荐表</div>}
            <Button shape="round" size={'large'}>
              {kclb?.provinceAdmin?.urlRecommend ? <a href={kclb?.provinceAdmin?.urlRecommend}>下载推荐表</a> : <a href={formUrl}>下载推荐表</a>}
            </Button>
            <Button onClick={() => derive()} shape="round" size={'large'}>
              <img src={daoChu} alt="" /> 导出
            </Button>
          </div>
        </header>
        <main>
          <Table rowSelection={{ type: selectionType, ...rowSelection, }}
            dataSource={playerlist} columns={columns} pagination={false} />;
        </main>
        <footer>
          <Pagination onChange={onPagination} total={number} current={current} pageSize={10} />
        </footer>
      </div>
    </Spin>

  )
}
